import {useCallback} from "react";
import {CatalogValueDto} from "../../client/catalog/CatalogValueDto";
import {useClientLocator} from "../../client/ApiClientLocator";
import {CatalogType} from "../../client/catalog/CatalogType";
import {useQuery} from "@tanstack/react-query";

interface UseCatalogValuesResult {
    getCatalogValueByCode: (code: string | undefined) => CatalogValueDto | undefined;
    catalogValues: CatalogValueDto[];
    isLoading: boolean;
    error: string | null;
}

export const useCatalog = (catalogType: CatalogType): UseCatalogValuesResult => {
    const {catalogClient} = useClientLocator();

    const {data: catalogValues = [], isLoading, error} = useQuery({
        queryKey: ['catalogs', catalogType],
        queryFn: () => catalogClient.findCatalogValues(catalogType),
        retry: 3,
        retryDelay: 1000,
        staleTime: 5 * 60 * 1000
    });

    const getCatalogValueByCode = useCallback(
        (code: string | undefined) => catalogValues.find(value => value.code === code),
        [catalogValues]
    );

    return {
        getCatalogValueByCode,
        catalogValues,
        isLoading,
        error: error instanceof Error ? error.message : null
    };
};